module.exports = __webpack_public_path__ + "img/a5.f03af433.png";